import { render, staticRenderFns } from "./StockyDataMigration.vue?vue&type=template&id=6dfcac95&scoped=true"
import script from "./StockyDataMigration.vue?vue&type=script&lang=ts"
export * from "./StockyDataMigration.vue?vue&type=script&lang=ts"
import style0 from "./StockyDataMigration.vue?vue&type=style&index=0&id=6dfcac95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfcac95",
  null
  
)

export default component.exports